<template>
  <element>
    <AppBar title="ReviewInvoice" />
    <v-container>
      <h3 class="category-label w-100 text-center">This is second dummy view for test.</h3>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"

export default {
  name: "ReviewInvoice",
  props: {},
  components: {
    AppBar
  },
  data() {
    return {}
  }
}
</script>

<style>

</style>